<div class="campanha-roi-chart">
    <div class="campanha-roi-chart-header">
        <sgt-campanha-roi-widgets
            [isLoading]="isLoading"
            [valorTotalRecursos]="chartCampanhas?.roi?.valorTotalDespesas"
            [valorTotalResultado]="chartCampanhas?.roi?.valorTotalVendas"
            [roi]="chartCampanhas?.roi?.retornoEfetivo">
        </sgt-campanha-roi-widgets>
    </div>

    <div class="campanha-roi-chart-body">
        <div class="card card-widget">
            <div class="card-header">
                <h6 class="card-title mb-2">
                    {{title}} 
                </h6>  
                <div class="card-header-tabs">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-target="#roiChartTabCampanhas" data-toggle="tab">
                                <i class="fas fa-bullhorn"></i> Campanhas
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-target="#roiChartTabPacotes" data-toggle="tab">
                                <i class="fas fa-cubes"></i> Pacotes
                            </a>
                        </li>                    
                    </ul>                
                </div>
            </div>
            <div class="tab-content">
                <div class="tab-pane active" id="roiChartTabCampanhas">
                    <sgt-campanha-roi-chart-table
                        [chart]="chartCampanhas"
                        [isVisualizacaoCampanhas]="true"
                        [isLoading]="isLoading"
                        [isEmpty]="isEmptyCampanhas">
                    </sgt-campanha-roi-chart-table>
                </div>
                <div class="tab-pane" id="roiChartTabPacotes">
                    <sgt-campanha-roi-chart-table
                        [chart]="chartPacotesCampanhas"
                        [isVisualizacaoPacotes]="true"
                        [isLoading]="isLoading"
                        [isEmpty]="isEmptyPacotesCampanhas">
                    </sgt-campanha-roi-chart-table>
                </div>
            </div>
            
        </div>
    </div>
</div>

